module.exports = __webpack_public_path__ + "static/media/wp-logo-no-background.98915878.svg";